// extracted by mini-css-extract-plugin
module.exports = {"image":"Support_image__3Tr35","header":"Support_header__1vxhT","rise-up":"Support_rise-up__1w5GF"};